module.exports = __webpack_public_path__ + "media/images/service/rj_code-e77371312f7b9d52004de6e22d910f5a.png";